<div class="app__container mt-10 flex flex-col gap-8 pb-20">
  @if(loadingQuote()){
    <div class="md:w-2/4 mx-auto">
     <activar-skeleton 
      [lines]="5"
      [widths]="['w-full', 'w-3/4', 'w-1/2', 'w-2/3', 'w-full', 'w-full' ,'w-full','w-full']"
      [height]="'h-5'"
    />
    <activar-skeleton  class="mt-5 flex"
      [lines]="8"
      [widths]="['w-full', 'w-3/4', 'w-1/2', 'w-2/3', 'w-full', 'w-full' ,'w-full','w-full']"
      [height]="'h-5'"
    />
    <activar-skeleton  class="mt-5 flex"
      [lines]="8"
      [widths]="['w-full', 'w-3/4', 'w-1/2', 'w-2/3', 'w-full', 'w-full' ,'w-full','w-full']"
      [height]="'h-5'"
    />
    </div>
  }@else{
    @if (paymentState().quote?.id && !showPaymentSection()) {
      <app-flow-resume-step class="md:w-2/4 mx-auto"
        [user]="quoteUser()"
        [insurableData]="quoteInsurable()"
        [selectedCoverage]="quoteCoverage()"
        [riskType]="quoteRiskType()"
        [currency]="quoteCurrency()"
        [additionalCoverage]="null"
        [quoteInfo]="null"
        [detailComponentType]="detailComponentType()"
        [detailData]="detailData()"
        [removable]="false"
      />
      <div class="px-5 md:w-2/4 mx-auto">
        <activar-button color="primary" text="Continuar" expand="full" (click)="continue()" />
      </div>
    }
  }
  

  @if (showPaymentSection()) {
  <div class="md:w-2/4 mx-auto">
    <activar-back-button class="mb-5" (click)="backToResume()" text="Volver" />
    <h2 class="mb-4">Seleccioná el medio de pago</h2>
    @if (!showAddCard()) {
      <div class="space-y-3">
        @for (paymentMethod of paymentMethods(); track paymentMethod.id) {
          <app-payment-method-item
            [paymentMethod]="paymentMethod"
            (paymentMethodSelected)="onPaymentMethodSelected($event)"
          />
        }
      </div>
    }

    @if (showPaymentButton()) {
      <div class="mt-6">
        <div class="mb-5"><app-disclaimer title="Importante" text="Serás redirigido a Mercado Pago"/></div>
        <activar-button color="primary" text="Pagar" expand="full" (click)="emitCash()" />
      </div>
    }

    @if (showAddCard()) {
      <div class="mt-6">
        <activar-back-button class="mb-5" (click)="goBack()" text="Volver" />
        <app-add-card (addPayment)="emit($event)" />
      </div>
    }
  </div>
  }
</div>

@if (loadingEmit()) {
  <activar-loading-overlay />
}
